import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../store';
import { TDialogState, TDialogVariant } from './types';

const initialState: TDialogState = {
  isOpen: false,
  variant: undefined,
  message: undefined,
};

const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    openDialog: (state, action: PayloadAction<Omit<TDialogState, 'isOpen'>>) => {
      state.isOpen = true;
      state.variant = action.payload.variant;
      state.message = action.payload.message;
    },
    closeDialog: (state) => {
      state.isOpen = false;
      state.variant = undefined;
      state.message = undefined;
    },
  },
});

export const { openDialog, closeDialog } = dialogSlice.actions;

export const selectIsDialogOpen = (state: RootState): boolean => state.dialog.isOpen;

export const selectDialogVariant = (state: RootState): TDialogVariant | undefined => state.dialog.variant;

export const selectDialogMessage = (state: RootState): string | undefined => state.dialog.message;

export default dialogSlice.reducer;
